export default {
  apiServerUrl: 'https://szwalnia.thecamels.pl/',
  useConfig: 'prod',
  additionalConfig: {
    'prod': {
      hplUrl: 'https://headwear.thecamels.pl/'
    },
    'dev': {
      hplUrl: 'https://headwear2.the-dev.org/'
    }
  }
};
